export const PageMyAccount = () => {

  return (
    <>
      <h1>My account</h1>
    </>
  );
};

